<template>
  <wrap :title="title" ref="wrap">
    <div class="title">{{d13.rule}}</div>
    <ul class="list">
      <li class="item clear_fix" v-for="(item,index) in list[category-1].rules" :key="index">
        <p class="label"><i class="before tbc"></i>{{item.label}}</p>
        <p class="value" v-if="item.type==1">{{item.value}}</p>
        <ol v-else-if="item.type==2">
          <li v-for="(child,i) in item.value" :key="i">
            <p class="c_before"></p>
            <p class="label">{{child.label}}</p>
            <p class="value"><span :class="[child.color]">{{child.value}}</span></p>
          </li>
        </ol>
      </li>
    </ul>
  </wrap>
</template>

<style lang="stylus" scoped>
  .title {
    line-height 30px;
    color: #000000;
    font-size: 14px;
    text-indent: 2em;
  }

  .list {
    .item {
      line-height 30px;
      color: #000000;
      font-size: 14px;
      padding-left 28px
      .label {
        padding-left: 20px;
        position: relative;
        margin-left: 30px;
        display: table-cell;
        /*white-space nowrap;*/
	word-break: break-all;
        height: 30px;

        .before {
          content: '';
          position absolute;
          left: 0;
          top: 15px;
          margin-top: -6px;
          width: 10px;
          height: 10px;
          border-radius 10px;
          border-style: solid;
          border-width 1px;
        }
      }

      .value {
        color: #666666;
        display: table-cell;
        word-break: break-all;
      }

      ol {
        li {

          margin-left: 30px;

          .c_before {
            display table-cell;
            content: '';
            width: 6px;
            margin: 0 5px;
            vertical-align: middle;

            &:before {
              content: '';
              display: block;
              height: 6px;
              width: 100%;
              background: #dddddd;
            }
          }

          .label {
            padding-left: 6px;
          }
        }
      }
    }
  }
</style>

<script>
  import Wrap from './wrap';
  import mixin from './mixin';
  import {mapState, mapActions} from 'vuex';

  export default {
    name: "QC13",
    mixins: [mixin],
    components: {Wrap},
    computed: {
      ...mapState({
        d13: state => state.table.d13,
        options: state => state.home.headTabs.map(item => ({
          label: item.title,
          value: item.lottery_type,
          category:item.category
        }))
      })
    },
    data() {
      return {
        type:0,
        lottery_type: '',
        category:1,
        ruleTitle:'',
        list:[
          {
            category:1,
            rules:[
              {type: 1, label: '两面：', value: '指单、双；大、小、尾大、尾小。'},
              {type: 1, label: '单、双：', value: '号码为双数叫双，如8、16；号码为单数叫单，如19、5。'},
              {type: 1, label: '大、小：', value: '开出之号码大于或等于11为大，小于或等于10为小。'},
              {type: 1, label: '尾大、尾小：', value: '开出之尾数大于或等于5为尾大，小于或等于4为尾小。'},
              {type: 1, label: '合单、合双：', value: '开出之个位数与十位数（十位没有的为0）之和为单的为合单，如5、9，开出之个位数与十位数（十位没有的为0）之和为双的为合双，如6、11。'},
              {
                type: 2,
                label: '中发白',
                value: [
                  {label: '中：', value: '“开出之号码为01、02、03、04、05、06、07。'},
                  {label: '发：', value: '“开出之号码为08、09、10、11、12、13、14。'},
                  {label: '白：', value: '开出之号码为15、16、17、18、19、20。'},
                  ]
              },
              {
                type: 2,
                label: '方位',
                value: [
                  {label: '东：', value: '开出之号码为01、05、09、13、17。'},
                  {label: '南：', value: '开出之号码为02、06、10、14、18。'},
                  {label: '西：', value: '开出之号码为03、07、11、15、19。'},
                  {label: '北：', value: '开出之号码为04、08、12、16、20。'}
                ]
              },
              {
                type: 2,
                label: '龙虎（以第一球的中奖号码和第八球的中奖号码做为对奖号码）',
                value: [
                  {label: '龙：', value: '开出之号码第一球的中奖号码大于第八球的中奖号码。如 第一球开出14 第八球开出09；第一球开出17 第八球开出08；第一球开出05 第八球开出01...中奖为龙。'},
                  {label: '虎：', value: '开出之号码第一球的中奖号码小于第八球的中奖号码。如 第一球开出14 第八球开出16；第一球开出13 第八球开出18；第一球开出05 第八球开出08...中奖为虎。'}
                ]
              },
              {type: 1, label: '正码：', value: '从01至20中任意选择1个号码进行投注， 投注号码与开奖号码中任意1个位置的号码相符，即中奖。'},
              {type: 1, label: '总和单双：', value: '所有8个开奖号码的数字总和值是单数为总和单，如数字总和值是31、51；所有8个开奖号码的数字总和值是双数为总和双，如数字总和是42、80；假如投注组合符合中奖结果，视为中奖，其余情形视为不中奖。'},
              {type: 1, label: '总和大小：', value: '从所有8个开奖号码的数字总和值85到132为总大；所有8个开奖号码的数字总和值36到83为总分小；所有8个开奖号码的数字总和值为84退还本金；如开奖号码为01、20、02、08、17、09、11，数字总和是68，则总分小。假如投注组合符合中奖结果，视为中奖，其余情形视为不中奖，打和不计算结果。'},
              {type: 1, label: '总尾大小：', value: '所有8个开奖号码的数字总和数值的个位数大于或等于5为总尾大，小于或等于4为总尾小；假如投注组合符合中奖结果，视为中奖，其余情形视为不中奖。'},
              {type: 1, label: '选二任选：', value: '指从01至20中任意选择2个号码对开奖号码中任意2个位置的投注。 投注号码与开奖号码中任意2个位置的号码相符，即中奖。'},
              {type: 1, label: '选二连组：', value: '从01至20中任意选择2个号码对开奖号码中按开奖顺序出现的2个连续位置的投注。 投注号码与开奖号码中按开奖顺序出现的2个连续位置的号码相符（顺序不限），即中奖。'},
              {type: 1, label: '选三任选：', value: '从指从01至20中任意选择3个号码对开奖号码中任意3个位置的投注。 投注号码与开奖号码中任意3个位置的号码相符，即中奖。'},
              {type: 1, label: '选三前组：', value: '指从01至20中任意选择3个号码对开奖号码中按开奖顺序出现的前3个连续位置的投注。 投注号码与开奖号码中按开奖顺序出现的前3个位置的号码相符（顺序不限），即中奖。'},
              {type: 1, label: '选四任选：', value: '指从01至20中任意选择4个号码，对开奖号码中任意4个位置的投注。 投注号码与开奖号码中任意4个位置的号码相符，即中奖。'},
              {type: 1, label: '选五任选：', value: '指从01至20中任意选择5个号码，对开奖号码中任意5个位置的投注。 投注号码与开奖号码中任意5个位置的号码相符，即中奖。。'},
            ]
          },
          {
            category:2,
            rules:[
             {
                type: 2,
                label: '第一球~第五球',
                value: [
                  {type: 1, label: '第一球特~第五球特：', value: '第一球特、第二球特、第三球特、第四球特、第五球特：指下注的每一球特与开出之号码其开奖顺序及开奖号码相同，视为中奖，如第一球开出号码8，下注第一球为8者视为中奖，其余情形视为不中奖。'},
                  {type: 1, label: '单双大小：', value: '根据相应单项投注第一球特 ~ 第五球特开出的球号，判断胜负。'},
                  {type: 1, label: '大小：', value: '根据相应单项投注的第一球特 ~ 第五球特开出的球号大於或等於5为特码大，小於或等於4为特码小。'},
                  {type: 1, label: '单双：', value: '根据相应单项投注的第一球特 ~ 第五球特开出的球号为双数叫特双，如2、6；特码为单数叫特单，如1、3。'}
                ]
              },
              {
                type: 2,
                label: '总和单双大小',
                value: [
                  {label: '大小：', value: '根据相应单项投注的第一球特 ~ 第五球特开出的球号大於或等於23为特码大，小於或等於22为特码小。'},
                  {label: '单双：', value: '根据相应单项投注的第一球特 ~ 第五球特开出的球号数字总和值是双数为总和双，数字总和值是单数为总和单。'},
                ]
              },
              {
                type: 2,
                label: '前三特殊玩法： 豹子 > 顺子 > 对子 > 半顺 > 杂六',
                value: [
                  {label: '豹子：', value: '中奖号码的个位十位百位数字都相同。----如中奖号码为000、111、999等，中奖号码的个位十位百位数字相同，则投注豹子者视为中奖，其它视为不中奖。'},
                  {label: '顺子：', value: '中奖号码的个位十位百位数字都相连，不分顺序。（数字9、0、1相连）----如中奖号码为123、901、321、546等，中奖号码个位十位百位数字相连，则投注顺子者视为中奖，其它视为不中奖。'},
                  {label: '对子：', value: '中奖号码的个位十位百位任意两位数字相同。（不包括豹子）----如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。如果开奖号码为豹子,则对子视为不中奖。如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。'},
                  {label: '半顺：', value: '中奖号码的个位十位百位任意两位数字相连，不分顺序。（不包括顺子、对子。）----如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。如果开奖号码为顺子、对子,则半顺视为不中奖。--如中奖号码为123、901、556、233，视为不中奖。'},
                  {label: '杂六：', value: '不包括豹子、对子、顺子、半顺的所有中奖号码。----如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。'}
                ]
              },
              {
                type: 2,
                label: '中三特殊玩法： 豹子 > 顺子 > 对子 > 半顺 > 杂六',
                value: [
                  {label: '豹子：', value: '中奖号码的十位百位千位数字都相同。----如中奖号码为000、111、999等，中奖号码的十位百位千位数字相同，则投注豹子者视为中奖，其它视为不中奖。'},
                  {label: '顺子：', value: '中奖号码的十位百位千位数字都相连，不分顺序。（数字9、0、1相连）----如中奖号码为123、901、321、546等，中奖号码十位百位千位数字相连，则投注顺子者视为中奖，其它视为不中奖。'},
                  {label: '对子：', value: '中奖号码的十位百位千位任意两位数字相同。（不包括豹子）----如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。如果开奖号码为豹子,则对子视为不中奖。如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。'},
                  {label: '半顺：', value: '中奖号码的十位百位千位任意两位数字相连，不分顺序。（不包括顺子、对子。）----如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。如果开奖号码为顺子、对子,则半顺视为不中奖。--如中奖号码为123、901、556、233，视为不中奖。'},
                  {label: '杂六：', value: '不包括豹子、对子、顺子、半顺的所有中奖号码。----如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。'}
                ]
              },
              {
                type: 2,
                label: '后三特殊玩法： 豹子 > 顺子 > 对子 > 半顺 > 杂六',
                value: [
                  {label: '豹子：', value: '中奖号码的百位千位万位数字都相同。----如中奖号码为000、111、999等，中奖号码的百位千位万位数字相同，则投注豹子者视为中奖，其它视为不中奖。'},
                  {label: '顺子：', value: '中奖号码的百位千位万位数字都相连，不分顺序。（数字9、0、1相连）----如中奖号码为123、901、321、546等，中奖号码百位千位万位数字相连，则投注顺子者视为中奖，其它视为不中奖。'},
                  {label: '对子：', value: '中奖号码的百位千位万位任意两位数字相同。（不包括豹子）----如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。如果开奖号码为豹子,则对子视为不中奖。如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。'},
                  {label: '半顺：', value: '中奖号码的百位千位万位任意两位数字相连，不分顺序。（不包括顺子、对子。）----如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。如果开奖号码为顺子、对子,则半顺视为不中奖。--如中奖号码为123、901、556、233，视为不中奖。'},
                  {label: '杂六：', value: '不包括豹子、对子、顺子、半顺的所有中奖号码。----如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。'}
                ]
              },
              {
                type: 2,
                label: '龙虎和特殊玩法： 龙 > 虎 > 和 （0为最小，9为最大）',
                value: [
                  {label: '龙：', value: '开出之号码第一球（万位）的中奖号码大于第五球（个位）的中奖号码，如出和局为打和。如 第一球开出4 第五球开出2；第一球开出9 第五球开出8；第一球开出5 第五球开出1...中奖为龙。 '},
                  {label: '虎：', value: '开出之号码第一球（万位）的中奖号码小于第五球（个位）的中奖号码，如出和局为打和。如 第一球开出7 第五球开出9；第一球开出3 第五球开出5；第一球开出5 第五球开出8...中奖为虎。 '},
                  {label: '和：', value: '开出之号码第一球（万位）的中奖号码等于第五球（个位）的中奖号码，例如开出结果：2***2则投注和局者视为中奖，其它视为不中奖。'},

                ]
              },
              {
                type: 2,
                label: '牛牛玩法',
                value: [
                  {label: '牛牛：', value: '根据开奖第一球 ~ 第五球开出的球号数字为基础，任意组合三个号码成0或10的倍数，取剩余两个号码之和为点数（大于10时减去10后的数字作为对奖基数，如：00026为牛8，02818为牛9，68628、23500皆为牛10俗称牛牛；26378、15286因任意三个号码都无法组合成0或10的倍数，称为没牛，注：当五个号码相同时，只有00000视为牛牛，其它11111，66666等皆视为没牛）'},
                  {label: '大小：', value: '牛大(牛6,牛7,牛8,牛9)，牛小(牛1,牛2,牛3,牛4,牛5)，若开出斗牛结果为没牛，则投注牛大牛小皆为不中奖。'},
                  {label: '单双：', value: '牛单(牛1,牛3,牛5,牛7,牛9)，牛双(牛2,牛4,牛6,牛8,牛牛)，若开出斗牛结果为没牛，则投注牛单牛双皆为不中奖。'},

                ]
              }
            ]
          },
          {
            category:3,
            rules:[
              {type: 1, label: '1~10 两面：', value: '指 单、双；大、小。'},
              {type: 1, label: '单、双：', value: '号码为双数叫双，如4、8；号码为单数叫单，如5、9。'},
              {type: 1, label: '大、小：', value: '开出之号码大于或等于6为大，小于或等于5为小。'},
              {type: 1, label: '第一名～第十名 车号指定：', value: '每一个车号为一投注组合，开奖结果“投注车号”对应所投名次视为中奖，其余情形视为不中奖。'},
              {
                type: 2,
                label: '1～5龙虎',
                value: [
                  {label: '冠 军 龙/虎：', value: '“第一名”车号大于“第十名”车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。'},
                  {label: '亚 军 龙/虎：', value: '“第二名”车号大于“第九名”车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。'},
                  {label: '第三名 龙/虎：', value: '“第三名”车号大于“第八名”车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。'},
                  {label: '第四名 龙/虎：', value: '“第四名”车号大于“第七名”车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。'},
                  {label: '第五名 龙/虎：', value: '“第五名”车号大于“第六名”车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。'},
                ]
              },
              {
                type: 2,
                label: '冠军车号＋亚军车号＝冠亚和值（为3~19)',
                value: [
                  {label: '冠亚和单双：', value: '“冠亚和值”为单视为投注“单”的注单视为中奖，为双视为投注“双”的注单视为中奖，其余视为不中奖。'},
                  {label: '冠亚和大小：', value: '“冠亚和值”大于11时投注“大”的注单视为中奖，小于或等于11时投注“小”的注单视为中奖，其余视为不中奖。'},
                  {label: '冠亚和指定：', value: '“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖。'}
                ]
              }
            ]
          },
          {
            category:4,
            rules:[
	      {type: 1, label: '以下所有投注皆含本金。', value: ''},	
              {
                type: 2,
                label: '特别号码：',
                value: [
                  {label: '', value: '六合彩公司当期开出的最后一码为特码'},
                  {label: '', value: '特码逢双为特双，特码逢单为特单，49号为和局'},
		  {label: '', value: '特码(01~24)为小；特码(25~48)为大。49号为和局'},
		  {label: '', value: '两面（指大、小、单、双、合双合单、合大合小、家禽、野兽、六肖、尾数大小）。49号为和局'},
		  {label: '', value: '特码合数大小：以特码个位和十位数字总和来判断胜负，和数大于或等于7为大，小于或等于6为小，开出49号为和。'},
		  {label: '', value: '特码合数单双：以特码个位和十位数字总和来判断单双，如01，12，32为和单，02，11，33为和双，开出49号为和。'},
		  {label: '', value: '特码尾数大小：以特别号尾数若0尾~4尾为小、5尾~9尾为大；如01、32、44为特尾小；如05、18、19为特尾大，开出49号为和'},
                  {label: '', value: '家禽【牛－马－羊－鸡－狗－猪－】'},
		  {label: '', value: '野兽【鼠－虎－兔－龙－蛇－猴－】'},
		]
              },
              {
                type: 2,
                label: '正码：',
                value: [
                  {label: '', value: '六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码1，依次叫正码2、正码3……正码6，不以大小排序。'},
                ]
              },
              {
                type: 2,
                label: '总分大小：',
                value: [
                  {label: '', value: '所有七个开奖号码的分数总和大於或等於175为总分大；分数总和小於或等於174为总分小。如开奖号码为01、07、15、29、38、46、24，分数总和是160，为总分小。'},
                ]
              },
              {
                type: 2,
                label: '总分单双：',
                value: [
                  {label: '', value: '所有七个开奖号码的分数总和是单数叫总分单(总单)，如分数总和是103、193；分数总和是双数叫总分双(总双)，如分数总和是108、160 特码单双：特码为双数叫特双，如2、18；特码为单数叫特单，如17、33'},
                ]
              },
              {
                type: 2,
                label: '正特:',
                value: [
                  {label: '', value: '正1特、正2特、正3特、正4特、正5特、正6特:指其下注的正码特号与开出之正码其开奖顺序及开奖号码相同，视为中奖，如现场摇珠第一个正码开奖为49号，下注正1特为49则视为中奖，其它号码视为不中奖，，其他正特项目依此类推。'},
                  {label: '', value: '大小单双和特别号码的大小单双等规则相同'},
                ]
              },
              {
                type: 2,
                label: '波色：指开出特码所属的颜色',
                value: [
                  {label: '红色号码包括：', color:'red',value: '01，02，07，08，12，13，18，19，23，24，29，30，34，35，40，45，46。'},
                  {label: '蓝色号码包括：',  color:'blue',value: '03，04，09，10，14，15，20，25，26，31，36，37，41，42，47，48。'},
                  {label: '绿色号码包括：',  color:'green',value: '05，06，11，16，17，21，22，27，28，32，33，38，39，43，44，49 。'},
                ]
              },
              {
                type: 2,
                label: '特肖首尾:',
                value: [
                  {label: '', value: '特肖指开奖的第7个号码（特别号码）是所属投注生肖的号码，就算中奖。'},
                  {label: '', value: '特尾是指开奖的第7个号码（特别号码）是所属投注尾数的号码，就算中奖，例如投注特尾1尾，只要特码是开1 11 21 31 41其中一个就算中奖。'},
                ]
              },
              {
                type: 2,
                label: '头数：',
                value: [
                  {label: '', value: ' 1-9为0头,1-9为0头,10-19为1头，20-29为2头，30-39为3头，40-49为4头，开奖的第7个号码（特别号码）是所属头数的号码，就算中奖。例如投注0头，特码只要开1-9的其中一个号码就算中奖。'},
                ]
              },
              {
                type: 2,
                label: '一肖尾数:',
                value: [
                  {label: '', value: ' 一肖中：挑选1个生肖(排列如同生肖)投注，若开奖号码的正码和特码在此生肖组合内 ，即视为中奖；重复开出来的也只计算一次中奖！'},
                  {label: '', value: '一肖不中：挑选1个生肖(排列如同生肖)投注，若开奖号码的正码和特码不在此生肖组合内 ，即视为中奖；重复开出来的也只计算一次中奖！'},
                  {label: '', value: '尾数中：开出的正码和特别号码中含有所属尾数的号码，就算中奖号码，重复开出来的也只计算一次中奖！'},
		  {label: '', value: '尾数不中：开出的正码和特别号码中不含有所属尾数的号码，就算中奖号码，重复开出来的也只计算一次中奖！'},
                ]
              },
              {
                type: 2,
                label: '连肖：（生肖的所对应的号码和特码生肖项目的一样，一个生肖的对应多个号码，无论同生肖的号码出现一个或多个，派彩只一次。每个生肖都有自己的赔率，下注组合的总赔率。取该组合生肖的最低赔率为总赔率。',
                value: [
                  {label: '二肖连[ 中 ]：', value: ' 选择两个生肖为一投注组合进行投注。该投注的两个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
                  {label: '三肖连[ 中 ]：', value: '选择三个生肖为一投注组合进行投注。该投注的三个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
                  {label: '四肖连[ 中 ]：', value: '选择四个生肖为一投注组合进行投注。该投注的四个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
		  {label: '五肖连[ 中 ]：', value: '选择五个生肖为一投注组合进行投注。该投注的五个生肖必须在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
		  {label: '二肖连[ 不中 ]：', value: '选择二个生肖为一投注组合进行投注。该投注的二个生肖必须都不在当期开出的7个开奖号码相对应的生肖中，视为中奖 。'},
		  {label: '三肖连[ 不中 ]：', value: '选择三个生肖为一投注组合进行投注。该投注的三个生肖必须都不在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
		  {label: '四肖连[ 不中 ]：', value: '选择四个生肖为一投注组合进行投注。该投注的四个生肖必须都不在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
		  {label: '五肖连[ 不中 ]：', value: '选择五个生肖为一投注组合进行投注。该投注的五个生肖必须都不在当期开出的7个开奖号码相对应的生肖中，视为中奖。'},
                ]
              },
              {
                type: 2,
                label: '连尾：（尾数的所对应的号码和特码尾数项目的一样，一个尾数的对应多个号码，无论同尾数的号码出现一个或多个，派彩只一次。每个尾数都有自己的赔率，下注组合的总赔率。取改组合尾数的最低赔率为总赔率。',
                value: [
                  {label: '二尾连[ 中 ]：', value: '选择两个尾数为一投注组合进行投注。该投注的两个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
                  {label: '三尾连[ 中 ]：', value: '选择三个尾数为一投注组合进行投注。该投注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
                  {label: '四尾连[ 中 ]：', value: '选择四个尾数为一投注组合进行投注。该投注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
		  {label: '二尾连[ 不中 ]：', value: '选择二个尾数为一投注组合进行投注。该投注的二个尾数必须都不在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
		  {label: '三尾连[ 不中 ]：', value: '选择三个尾数为一投注组合进行投注。该投注的三个尾数必须都不在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
		  {label: '四尾连[ 不中 ]：', value: '选择四个尾数为一投注组合进行投注。该投注的四个尾数必须都不在当期开出的7个开奖号码相对应的尾数中，视为中奖。'},
                ]
              },
              {
                type: 2,
                label: '连码：',
                value: [
                  {label: '三全中：', value: '每三号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其余情形视为不中奖。如03、04、05三个都是开奖号码之正码，视为中奖，如两个正码加上一个特别号码，视为不中奖。'},
                  {label: '三中二：', value: '所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，视为中奖，叫三中二；若3个都是开奖号码中的正码，叫三中二之中三，其余情形视为不中奖，如03、04、05为一组合，开奖结果中有03、04两个正码，没有05，叫三中二，按三中二赔付；如开奖中有03、04、05三个正码，叫三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。'},
                  {label: '二全中：', value: '每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其余情形视为不中奖（含一个正码加一个特别号码之情形）。'},
		  {label: '二中特：', value: '二中特.中二就是中了两个正码视为中二.中特:一个中特一个正码.算为中 特。'},
		  {label: '特 串：', value: '每二个号码为一组合，其中一个是正码，一个是特别号码，视为中奖，其余情形视为不中奖（含二个号码都是正码之情形）  。'},
		  {label: '', value: '依照二全中•二中特•特串 此3种玩法规则,来进行‘生肖对碰’或‘尾数对碰’及混合对碰。例一：选择‘二全中’,之后进行‘生肖对碰’选择猪(2，14，26，38)以及鼠 (1，13，25，37，49)则会产生20组号码组合：[2,1] [2,13] [2,25] [2,37] [2,49][14,1] [14,13] [14,25] [14,37] [14,49][26,1] [26,13] [26,25] [26,37] [26,49][38,1] [38,13] [38,25] [38,37] [38,49]  。'},
		  {label: '', value: '例二：选择‘二中特’,之后进行‘尾数对碰’选择0(10，20，30，40)以及5(5，15，25，35，45)则会产生20组号码组合：[10,5] [10,15] [10,25] [10,35] [10,45][20,5] [20,15] [20,25] [20,35] [20,45][30,5] [30,15] [30,25] [30,35] [30,45][40,5] [40,15] [40,25] [40,35] [40,45]•	例三：•	选择特串：之后选择混合对碰，选择鼠（01， 13 ，25， 37 ，49）碰1尾（1，11，21，341，41），则会产生24组号码组合：[1,11] [1,21] [1,31] [1,41][13,1] [13,11] [13,21] [13,31] [13,41][25,1] [25,11] [25,21] [25,31] [25,41][37,1] [37,11] [37,21] [37,31] [37,41][49,1] [49,11] [49,21] [49,31] [49,41]'},
		]
              },
              {
                type: 2,
                label: '自选不中：',
                value: [
                  {label: '五不中：', value: '挑选5个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
                  {label: '六不中', value: '挑选6个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
		  {label: '七不中', value: '挑选7个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
		  {label: '八不中', value: '挑选8个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
		  {label: '九不中', value: '挑选9个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
      {label: '十不中', value: '挑选10个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
      {label: '十一不中', value: '挑选11个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
      {label: '十二不中', value: '挑选2个号码为一个组合下注，如果开奖的七个号码（正码与特码）不是这组合的号码就算中奖。'},
                ]
              },
              {
                type: 2,
                label: '总肖：',
                value: [
                  {label: '2肖：', value: '投注2肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是2个就算中奖。'},
                  {label: '3肖：', value: '投注3肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是3个就算中奖。'},
                  {label: '4肖：', value: '投注4肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是4个就算中奖。'},
		  {label: '5肖：', value: '投注5肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是5个就算中奖。'},
		  {label: '6肖：', value: '投注6肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是6个就算中奖。'},
		  {label: '7肖：', value: '投注7肖，如果开奖的七个号码（正码与特码）对应的生肖总数和刚好是7个就算中奖。'},
		  {label: '总肖单 ：', value: '如果开奖的七个号码（正码与特码）对应的生肖总数和是单就算中奖。'},
		  {label: '总肖双 ：', value: '如果开奖的七个号码（正码与特码）对应的生肖总数和是双就算中奖。'},
                ]
              },
              {
                type: 2,
                label: '合肖：',
                value: [
                  {label: '', value: '挑选2-6生肖(排列如同生肖)为一个组合，若开奖号码的特码亦在此组合内 ，即视为中奖；选择投注6肖，如果特码开49打和'},
                ]
              },
              {
                type: 2,
                label: '特平中：',
                value: [
                  {label: '', value: '选择1至5个号码为一个投注组合，如果开奖号码的正码与特码亦在此组合内 ，即视为中奖；重复开出也只计算一次中奖'},
                ]
              },
              {
                type: 2,
                label: '中一：',
                value: [
                  {label: '', value: '挑选4-10个号码为一投注组合，若开奖号码的正码和特码有一个号码在其中视为中奖'},
                ]
              },
              {
                type: 2,
                label: '半波：',
                value: [
                  {label: '', value: '以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖。 开49则算打和'},
                ]
              },
              {
                type: 2,
                label: '五行：',
                value: [
                  {label: '', value: '当期开出的特码号为所属五行中的号码即为中奖：例如选择投注金，只要特码是开01，06，11，16，21，26，31，36，41，46其中一个号码就算中奖。开49不打和'},
                  {label: '金：', value: '01，06，11，16，21，26，31，36，41，46'},
                  {label: '木：', value: '02，07，12，17，22，27，32，37，42，47'},
		  {label: '水：', value: '03，08，13，18，23，28，33，38，43，48'},
		  {label: '火：', value: '04，09，14，19，24，29，34，39，44，49'},
		  {label: '土：', value: '05，10，15，20，25，30，35，40，45'},
                ]
              },
            ]
          },
          {
            category:5,
            rules:[
              {type: 1, label: '以下所有投注皆含本金。', value: ''},
              {type: 1, label: '此游戏将以「BINGO BINGO宾果宾果」结合番摊的下注方式进行，以「BINGO BINGO宾果宾果」的超级奖号除四的余数为开奖结果， 番摊下注的数字则为１２３４；例「BINGO BINGO宾果宾果」特别号除四余数为１等于番摊开１，超级奖号加总除四余数为２等于番摊开２，超级奖号加总除四余数为３等于番摊开３，超级奖号加总除四余数为０等于番摊开４。', value: ''},
              {
                type: 2,
                label: '正：于自1~4任选1号进行投注，当开奖结果与所选的号码相同时，即为中奖。',
                value: [
                  {label: '', value: '开出号码加总除四余数为1，中奖为1，不中奖为3，其他视为和局；'},
                  {label: '', value: '开出号码加总除四余数为2，中奖为2，不中奖为4，其他视为和局；'},
                  {label: '', value: '开出号码加总除四余数为3，中奖为3，不中奖为1，其他视为和局；'},
                  {label: '', value: '开出号码加总除四余数为0，中奖为4，不中奖为2，其他视为和局。'},
                ]
              },
              {
                type: 2,
                label: '番：于自1~4任选1号进行投注，当开奖结果与所选的号码相同时，即为中奖。',
                value: [
                  {label: '', value: '开出号码加总除四余数为1，中奖为1，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为2，中奖为2，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为3，中奖为3，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为0，中奖为4，其他视为不中奖。'},
                ]
              },
              {
                type: 2,
                label: '角：于自1-2，2-3，3-4，1-4任选1个进行投注，当开奖结果与所选的号码相同时，即为中奖。',
                value: [
                  {label: '', value: '开出号码加总除四余数为1，中奖为1-2角、1-4角，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为2，中奖为2-3角、1-2角，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为3，中奖为2-3角、3-4角，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为0，中奖为1-4角、3-4角，其他视为不中奖。'},
                ]
              },
              {
                type: 2,
                label: '念：于自A念B，任选1个进行投注，当开奖结果与A号码相同时，即为中奖，当开奖结果与B号码时，则为和局，其他视为不中奖。',
                value: [
                  {label: '', value: '开出号码加总除四余数为1，中奖为1念2、1念3、1念4，和局为2念1、3念1、4念1，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为2，中奖为2念1、2念3、2念4，和局为1念2、3念2、4念2，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为3，中奖为3念1、3念2、3念4，和局为1念3、2念3、4念3，其他视为不中奖；'},
                  {label: '', value: '开出号码加总除四余数为0，中奖为4念1、4念2、4念3，和局为1念4、2念4、3念4，其他视为不中奖。'},
                ]
              },
              {type: 1, label: '单，双：', value: '于自单或双任选1个进行投注，当开奖结果为单数则单数中奖，其他视为不中奖。当开奖结果为双数则双数中奖，其他视为不中奖。'},
              {type: 1, label: '三门：', value: '投注三个号码，开出为赢，其余为输'},
              {type: 1, label: '通：', value: '投注两个号码，开出为赢，其余两个号码自由选定一和、一输。例如: 下 一通23，开23为赢、开1为输、开4为和'},
            ]
          }
        ]
      };
    },
    mounted() {
      const show = this.show;
      this.show = () => {
        const info = this.options.find(item => item.value == this.data.lottery_type);
        this.type = info ? info.value : this.options[0].value;
        //this.category = info ? info.category : this.options[0].category;
        this.category = this.category_id;
        return show.call(this, ...arguments);
      };
    },
    methods: {
      ...mapActions('table', {
        load_d13_data: 'load_d13_data'
      }),
      loadInfo() {
        this.load_d13_data({
          lottery_type: this.lottery_type
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dialog/QC13.vue